import IQuestion from "../interfaces/IQuestion";
import IQuestionOption from "../interfaces/IQuestionOption";

export default class Questionaire<T extends {}> {
	private questions: IQuestion<T>[];

	constructor(questions: IQuestion<T>[]) {
		this.questions = questions;
	}

	public getEntry(): IQuestion<T> {
		return this.questions.filter(
			(question: IQuestion<T>) => question.isEntry
		)[0];
	}

	public static getNext<T extends {}>(
		questionaire: IQuestion<T>[],
		option: IQuestionOption<T>,
		current: IQuestion<T>
	): IQuestion<T> | null {
		if (option.nextId === "end") {
			return null;
		}

		const nextQuestion: IQuestion<T> = questionaire.filter(
			(question: IQuestion<T>) => question.id === option.nextId
		)[0];

		nextQuestion.prevId = current.id;

		return nextQuestion;
	}

	public static getPrev<T extends {}>(
		questionaire: IQuestion<T>[],
		current: IQuestion<T>
	): IQuestion<T> | null {
		const prevQuestion: IQuestion<T> = questionaire.filter(
			(question: IQuestion<T>) => question.id === current.prevId
		)[0];

		return prevQuestion;
	}
}
